// Listen for click event on image and link user to article
document.querySelectorAll('.article--index').forEach((el) => {
  const articleImage = el.querySelector('.article--index__image');
  const articleLinkPath = el.querySelector('.article--index__link').href;

  if (articleImage) {
    articleImage.addEventListener('click', () => {
      window.location.href = articleLinkPath;
    });
  }
});
